import { defineComponent as _defineComponent } from 'vue'
import { useAppStore } from '@/stores/pinia/useAppStore';
import { storeToRefs } from 'pinia';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CanaryMarker',
  setup(__props) {

const { xServeTrack } = storeToRefs(useAppStore());

// Helper function to format date
function formatCommitDate(dateStr: string) {
	const date = new Date(dateStr);
	const now = new Date();
	const diffMs = now.getTime() - date.getTime();
	const diffMins = Math.floor(diffMs / (1000 * 60));
	const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
	const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

	if (diffMins < 1) return 'just now';
	if (diffMins < 60) return `${diffMins} minute${diffMins !== 1 ? 's' : ''} ago`;
	if (diffHours < 24) return `${diffHours} hour${diffHours !== 1 ? 's' : ''} ago`;
	if (diffDays < 7) return `${diffDays} day${diffDays !== 1 ? 's' : ''} ago`;

	// For older commits, show the actual date and time
	return date.toLocaleString('en-US', {
		month: 'short',
		day: 'numeric',
		hour: '2-digit',
		minute: '2-digit',
		hour12: false,
	});
}

// Expanded state
const isExpanded = ref(false);

const canaryMarker = computed(() => {
	const envCanary = JW_CONFIG.PR_CANARY_FLAG;
	if (envCanary) return envCanary;

	if (xServeTrack.value == null || xServeTrack.value === 'prod' || xServeTrack.value === 'canary-public') return null;

	return xServeTrack.value.replaceAll('-', ' ');
});

const isPrCanary = JW_CONFIG.PR_CANARY_FLAG != null;

const prCanaryPrTitle = JW_CONFIG.PR_CANARY_PR_TITLE;
const prCanaryPrAuthor = JW_CONFIG.PR_CANARY_PR_AUTHOR;
const prCanaryPrUrl = JW_CONFIG.PR_CANARY_PR_URL;
const prCanaryLastCommitMsg = JW_CONFIG.PR_CANARY_LAST_COMMIT_MSG;
const prCanaryLastCommitDate = JW_CONFIG.PR_CANARY_LAST_COMMIT_DATE;
const prCanaryLastCommitId = JW_CONFIG.PR_CANARY_LAST_COMMIT_ID;
const prCanaryIsLatestCommit = JW_CONFIG.PR_CANARY_IS_LATEST_COMMIT ?? true;
const prCanaryDeploymentType = JW_CONFIG.PR_CANARY_DEPLOYMENT_TYPE ?? 'SSR';

function toggleExpanded() {
	isExpanded.value = !isExpanded.value;
}

function exitPrCanary() {
	const url = new URL(window.location.href);
	url.searchParams.set('exit-pr-canary', 'true');
	url.searchParams.delete('pr-canary');
	window.location.href = url.toString();
}

return { __sfc: true,xServeTrack, formatCommitDate, isExpanded, canaryMarker, isPrCanary, prCanaryPrTitle, prCanaryPrAuthor, prCanaryPrUrl, prCanaryLastCommitMsg, prCanaryLastCommitDate, prCanaryLastCommitId, prCanaryIsLatestCommit, prCanaryDeploymentType, toggleExpanded, exitPrCanary }
}

})